import type { ISubmitBidFeedbackParams } from '../clients/SubmitBidFeedback';
import * as Client from '../clients/SubmitBidFeedback';

export const submitBidFeedbackService = async (params: ISubmitBidFeedbackParams): Promise<void> => {
  await Client.submitBidFeedback(params);
};
